import { render, staticRenderFns } from "./nested-draggable.vue?vue&type=template&id=716f873e&scoped=true&"
import script from "./nested-draggable.vue?vue&type=script&lang=js&"
export * from "./nested-draggable.vue?vue&type=script&lang=js&"
import style0 from "./nested-draggable.vue?vue&type=style&index=0&id=716f873e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716f873e",
  null
  
)

export default component.exports